import { ILKDSConnectionRequest, ILPConnectionRequest } from '@/pages/Equipment/equipment.types.ts'
import { useRecoilValue } from 'recoil'
import equipmentAtom from '@/pages/Equipment/atoms/equipment.atom.ts'
import { useMemo, useState } from 'react'
import Tag from '@/shared/Tags/Tag'
import alertService from '@/services/alerts/alert.service.ts'
import CreateEquipmentSidePage from '@/pages/Equipment/components/SidePages/CreateEquipmentSidePage'
import equipmentUtils from '@/pages/Equipment/equipment.utils.ts'

type IProps =
  | { protocol: 'lp-lift'; request: ILPConnectionRequest }
  | { protocol: 'lkds'; request: ILKDSConnectionRequest }

const ConnectionRequestStatus = (props: IProps) => {
  const [createdSidePageOpen, setCreateSidePageOpen] = useState(false)
  const equipmentList = useRecoilValue(equipmentAtom).items
  const connectionConfigurationKey = props.protocol === 'lkds' ? 'clientId' : 'controllerId'
  const connectionId = props.protocol === 'lkds' ? props.request.clientId : props.request.controllerId
  const connectionConfiguration = { [connectionConfigurationKey]: connectionId }

  const isConnected = useMemo(() => {
    return equipmentList.some((equipment) => {
      if (equipment.protocolId !== props.protocol) return false

      const configuredConnectionId = equipment.connectionConfiguration?.[connectionConfigurationKey]
      if (typeof configuredConnectionId !== 'string') return false

      return props.protocol === 'lkds'
        ? configuredConnectionId.toLowerCase() === connectionId.toLowerCase()
        : configuredConnectionId === connectionId
    })
  }, [equipmentList, props.protocol, connectionConfigurationKey, connectionId])

  const handleSidePageClose = (created: boolean) => {
    setCreateSidePageOpen(false)

    if (created === true) {
      alertService.requestAlert({
        type: 'success',
        title: 'Лифт добавлен в систему!',
        description: 'Вы можете найти его на карте, а также во вкладке "Устройства".',
      })
    }
  }

  if (isConnected) {
    return <Tag color="green">Лифт уже подключен к системе</Tag>
  }

  return (
    <>
      <CreateEquipmentSidePage
        open={createdSidePageOpen}
        onClose={handleSidePageClose}
        initialState={{
          ...equipmentUtils.generateEmptyEquipment(),
          protocolId: props.protocol,
          connectionConfiguration,
        }}
      />
      <p className="text-nm text-link" style={{ textDecoration: 'none' }} onClick={() => setCreateSidePageOpen(true)}>
        Добавить лифт
      </p>
    </>
  )
}

export default ConnectionRequestStatus
